// extracted by mini-css-extract-plugin
export default {"productCards":"styles_productCards__uZ353","spinner":"styles_spinner__Qx8Sk"};